import React from "react";
import PropTypes from "prop-types";
import { translate, Trans } from "react-i18next";

const StepFooter = ({ t, className,loginUrl }) => (
	<footer className={className}>
		<p>
			<Trans i18nKey="tandc" parent="small">
				By signing up, you agree to our{" "}
				<a
					href="https://www.damstratechnology.com/terms-conditions#terms-conditions"
					target="_blank"
					rel="noreferrer noopener"
				>
					terms and conditions
				</a>.
			</Trans>
		</p>
		<Trans i18nKey="alreadyMemberLink" parent="p" className="h5">
			Already have an account? <a href={loginUrl}>Log in</a>
		</Trans>
	</footer>
);

StepFooter.propTypes = {
	t: PropTypes.func,
	className: PropTypes.string,
	loginUrl: PropTypes.string,
};

export default translate()(StepFooter);
